import React, { FC, useState, useEffect, useMemo, useRef } from 'react'
import CreatableSelect from 'react-select/creatable';
import * as Yup from 'yup'
import { useFormik } from 'formik'
import ReactSelect from 'react-select';
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { isNotEmpty, toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import { initialEvent, Event } from '../core/_models'
import clsx from 'clsx'
import { useListView } from '../core/ListViewProvider'
import { EventsListLoading } from '../components/loading/EventsListLoading'
import { createEvent, updateEvent, uploadAndUpdate } from '../core/_requests'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { convertArrToSelect, containsId } from '../../../../../../jsFunctions';
import { RadioInput, addDaysToDate, removeSpaces, copyToClipboard } from '../../../../../../jsFunctions';
import { PrintingTemplateOption } from '../../../template-management/templates-list/core/_requests';
// import { getDateTime } from '../../../../../../jsFunctions';
type Props = {
  isEventLoading: boolean
  event: Event
  clients: DropdownOptions[]
  memoryMakers: DropdownOptions[]
  printerDevices: DropdownOptions[]
  templates: DropdownOptions[]
  frames: DropdownOptions[]
  printingTemplates?: PrintingTemplateOption[]
  isPrintingTemplatesLoading?: boolean
  printingTemplatesError?: string
}

interface PrintableTemplatePreviewState {
  avatar: string
  label: string
  value: string
  top: number
  left: number
}

const editEventSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Name is required'),
  startDate: Yup.mixed().notOneOf([null], 'Start Date is required').required('Start Date is required'),
  endDate: Yup.mixed().notOneOf([null], 'End Date is required').required('End Date is required'),
})


interface DropdownOptions {
  readonly value: string;
  readonly image?: string;
  readonly avatar?: string;
  readonly id?: string;
  readonly uid?: string;
  readonly label: string;
  readonly email?: string;
  readonly tags?: Array<string>;
  readonly archive?: boolean;
  readonly data?: any;
}

const dropdownOptions: readonly DropdownOptions[] = [
  { value: 'event', label: 'event' },
  { value: 'client', label: 'client' },
  { value: 'testing', label: 'testing' },
  { value: 'SAYCHEESE', label: 'SAYCHEESE' },
];

const getSelectOptions = (items: any): DropdownOptions[] => {
  if (!Array.isArray(items)) {
    return []
  }

  return items
    .map((item: any) => ({
      ...item,
      value: String(item?.value || item?.id || '').trim(),
      label: String(item?.label || item?.name || item?.value || item?.id || '').trim(),
    }))
    .filter((item: DropdownOptions) => item.value && item.label)
}

const printerDevicesToOptions = (printerDevices: any): DropdownOptions[] => {
  if (Array.isArray(printerDevices)) {
    return getSelectOptions(printerDevices)
  }

  if (!printerDevices || typeof printerDevices !== 'object') {
    return []
  }

  return Object.entries(printerDevices)
    .filter(([, printerDevice]) => (printerDevice as any)?.enabled !== false)
    .map(([deviceId, printerDevice]) => {
      const device = printerDevice as {label?: string}

      return {
        value: deviceId,
        id: deviceId,
        label: device.label || deviceId,
      }
    })
}

const getMemoryMakerUid = (memoryMaker: DropdownOptions): string =>
  memoryMaker.uid || memoryMaker.data?.uid || memoryMaker.value || memoryMaker.id || ''

const getMemoryMakerLegacyId = (memoryMaker: DropdownOptions): string =>
  memoryMaker.id || memoryMaker.value || memoryMaker.data?.id || ''

const EventEditModalForm: FC<Props> = ({
  event,
  isEventLoading,
  clients,
  memoryMakers,
  printerDevices,
  templates,
  frames,
  printingTemplates = [],
  isPrintingTemplatesLoading = false,
  printingTemplatesError = '',
}) => {
  const { setItemIdForUpdate } = useListView()

  const { refetch } = useQueryResponse()
  const printableTemplateBaseUrl = 'https://saycheese-editor.web.app/'

  const [eventForEdit] = useState<Event>({
    ...event,
    avatar: event.avatar || initialEvent.avatar,
    info: event.info || initialEvent.info,
    name: event.name || initialEvent.name,
    parent: event.parent || initialEvent.parent,
    sendgrid: event.sendgrid?.length ? event.sendgrid : 'd-26fae6d8ec634424a738c8826c53d2b2',
    sendgridDooh: event.sendgridDooh?.length ? event.sendgridDooh : 'd-26fae6d8ec634424a738c8826c53d2b2',
    printableTemplateId: event.printableTemplateId || initialEvent.printableTemplateId,
    initialToolFrame: event.initialToolFrame ?? initialEvent.initialToolFrame,
    autoPrint: event.autoPrint ?? initialEvent.autoPrint,
    printerDevices: printerDevicesToOptions(event.printerDevices),
    defaultPrinterDeviceId: event.defaultPrinterDeviceId || initialEvent.defaultPrinterDeviceId,
    printerAssignments: event.printerAssignments || initialEvent.printerAssignments,
    // form:("https://yourstorywall.com/content/FRM_" + event.projectNo + "_" + removeSpaces(event.parent[0].label) + "_" + event.startDate.toISOString().slice(0, -14)).toLocaleLowerCase(),
    tags: event.tags ? convertArrToSelect(event.tags) : dropdownOptions
  })

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate(undefined)
  }

  const blankImg = toAbsoluteUrl('/media/svg/avatars/blank.svg')
  const eventAvatarImg = toAbsoluteUrl(`/media/${eventForEdit.avatar}`)
  const [avatar, setAvatar] = useState<any>(eventForEdit.avatar);
  const [startDate, setStartDate] = useState<any>(eventForEdit.startDate);
  const [endDate, setEndDate] = useState<any>(eventForEdit.endDate);
  const handleChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ): Promise<any> => {
    // const { target } = event;
    // const img = new Image();

    const ImageName = event.target.value.split('\\')[2];
    const Image = event.target.value;
    console.log('Imageon Kevel: ', Image); // Image on Kevel
    console.log('ImageName on Kevel: ', ImageName); // ImageName on Kevel
    console.log('ImageLink on Kevel: ', event.target.value); // ImageLink on Kevel
    console.log('event current Target files: ', event.target?.files?.[0]);

    if (event?.target?.files?.[0]!) {
      setAvatar({ display: URL.createObjectURL(event?.target?.files?.[0]), upload: event?.target?.files?.[0] });
    }
  };

  const formik = useFormik({
    initialValues: eventForEdit,
    validationSchema: editEventSchema,
    onSubmit: async (values, { setSubmitting }) => {

      console.log("onSubmit ", event)

      // alert(values.micrositeDate)

      setSubmitting(true)

      try {
        if (isNotEmpty(values.id)) {
          await updateEvent({ ...values })
          if (avatar.upload && values.id) {
            uploadAndUpdate(values.id, avatar.upload, values.id)
          }
        } else {
          await createEvent({ ...values, avatar: avatar.upload })
        }
      } catch (ex) {
        console.error(ex)
      } finally {
        setSubmitting(true)
        cancel(true)
      }
    },
  })

  const printableTemplateId = typeof formik.values.printableTemplateId === 'string'
    ? formik.values.printableTemplateId.trim()
    : ''
  const printableTemplateUrl = printableTemplateId
    ? `${printableTemplateBaseUrl}?templateId=${encodeURIComponent(printableTemplateId)}`
    : printableTemplateBaseUrl
  const printableTemplateSelectKey = `${event.id || 'new'}-${printableTemplateId || 'empty'}`

  const selectedPrintingTemplate = useMemo(
    () => {
      if (!printableTemplateId) {
        return null
      }

      return printingTemplates.find((item) => item.value === printableTemplateId) || {
        value: printableTemplateId,
        label: printableTemplateId,
        id: printableTemplateId,
        tags: [],
      }
    },
    [printingTemplates, printableTemplateId]
  )

  const [printableTemplatePreview, setPrintableTemplatePreview] =
    useState<PrintableTemplatePreviewState | null>(null)
  const printableTemplatePreviewShowTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)
  const printableTemplatePreviewHideTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const clearPrintableTemplatePreviewTimers = () => {
    if (printableTemplatePreviewShowTimeoutRef.current) {
      clearTimeout(printableTemplatePreviewShowTimeoutRef.current)
      printableTemplatePreviewShowTimeoutRef.current = null
    }

    if (printableTemplatePreviewHideTimeoutRef.current) {
      clearTimeout(printableTemplatePreviewHideTimeoutRef.current)
      printableTemplatePreviewHideTimeoutRef.current = null
    }
  }

  const schedulePrintableTemplatePreviewHide = () => {
    if (printableTemplatePreviewShowTimeoutRef.current) {
      clearTimeout(printableTemplatePreviewShowTimeoutRef.current)
      printableTemplatePreviewShowTimeoutRef.current = null
    }

    if (printableTemplatePreviewHideTimeoutRef.current) {
      clearTimeout(printableTemplatePreviewHideTimeoutRef.current)
    }

    printableTemplatePreviewHideTimeoutRef.current = setTimeout(() => {
      setPrintableTemplatePreview(null)
      printableTemplatePreviewHideTimeoutRef.current = null
    }, 160)
  }

  const showPrintableTemplatePreview = (
    mouseEvent: React.MouseEvent<HTMLElement>,
    option: PrintingTemplateOption
  ) => {
    if (!option.avatar) {
      return
    }

    if (printableTemplatePreviewHideTimeoutRef.current) {
      clearTimeout(printableTemplatePreviewHideTimeoutRef.current)
      printableTemplatePreviewHideTimeoutRef.current = null
    }

    if (printableTemplatePreviewShowTimeoutRef.current) {
      clearTimeout(printableTemplatePreviewShowTimeoutRef.current)
    }

    const target = mouseEvent.currentTarget
    printableTemplatePreviewShowTimeoutRef.current = setTimeout(() => {
      const targetRect = target.getBoundingClientRect()
      const previewWidth = 300
      const previewHeight = 440
      const viewportPadding = 20
      const viewportWidth = window.innerWidth
      const viewportHeight = window.innerHeight

      let left = targetRect.left + targetRect.width / 2
      let top = targetRect.top + targetRect.height / 2

      if (left + previewWidth / 2 > viewportWidth - viewportPadding) {
        left = viewportWidth - previewWidth / 2 - viewportPadding
      } else if (left - previewWidth / 2 < viewportPadding) {
        left = previewWidth / 2 + viewportPadding
      }

      if (top + previewHeight / 2 > viewportHeight - viewportPadding) {
        top = viewportHeight - previewHeight / 2 - viewportPadding
      } else if (top - previewHeight / 2 < viewportPadding) {
        top = previewHeight / 2 + viewportPadding
      }

      setPrintableTemplatePreview({
        avatar: option.avatar || '',
        label: option.label,
        value: option.value,
        top,
        left,
      })

      printableTemplatePreviewShowTimeoutRef.current = null
    }, 200)
  }

  useEffect(() => {
    return () => {
      if (printableTemplatePreviewShowTimeoutRef.current) {
        clearTimeout(printableTemplatePreviewShowTimeoutRef.current)
      }
      if (printableTemplatePreviewHideTimeoutRef.current) {
        clearTimeout(printableTemplatePreviewHideTimeoutRef.current)
      }
    }
  }, [])

  const selectedMemoryMakers = useMemo(
    () => getSelectOptions(formik.values.memoryMakers),
    [formik.values.memoryMakers]
  )

  const selectedPrinterDevices = useMemo(
    () => getSelectOptions(formik.values.printerDevices),
    [formik.values.printerDevices]
  )

  const selectedDefaultPrinterDevice = useMemo(
    () => selectedPrinterDevices.find((printerDevice) => printerDevice.value === formik.values.defaultPrinterDeviceId) || null,
    [formik.values.defaultPrinterDeviceId, selectedPrinterDevices]
  )

  const compactSelectStyles = useMemo(() => ({
    option: (base: any) => ({
      ...base,
    }),
    multiValue: (styles: any, { data }: any) => ({
      ...styles,
      borderRadius: 10,
      backgroundColor: data.archive ? '#7239ea73  ' : '#432cffb8',
      padding: 4,
      margin: 4,
      color: 'white',
      boxShadow: '#0303030f 0px 0px 20px 0px',
    }),
    multiValueLabel: (styles: any) => ({
      ...styles,
      fontWeight: 'bold',
      color: 'white',
    }),
    multiValueRemove: (styles: any) => ({
      ...styles,
      ':hover': {
        color: 'gray',
      },
    }),
    control: (base: any) => ({
      ...base,
      padding: '5px',
      border: 'none',
      borderRadius: 10,
      boxShadow: '#3d88a614 0px 0px 20px 0px',
    }),
    menu: (base: any) => ({
      ...base,
      backgroundColor: 'white',
      padding: '10px',
      border: 'none',
      borderRadius: 10,
      boxShadow: '#3d88a614 0px 0px 20px 0px',
      zIndex: 5,
    }),
    singleValue: (base: any) => ({ ...base, color: '#000', borderRadius: 10 }),
  }), [])

  useEffect(() => {
    const printerDeviceIds = selectedPrinterDevices.map((printerDevice) => printerDevice.value)
    const defaultPrinterDeviceId = typeof formik.values.defaultPrinterDeviceId === 'string'
      ? formik.values.defaultPrinterDeviceId
      : ''
    const nextDefaultPrinterDeviceId = printerDeviceIds.includes(defaultPrinterDeviceId)
      ? defaultPrinterDeviceId
      : printerDeviceIds[0] || ''

    if (defaultPrinterDeviceId !== nextDefaultPrinterDeviceId) {
      formik.setFieldValue('defaultPrinterDeviceId', nextDefaultPrinterDeviceId, false)
    }

    const currentMemoryMakerToDevice = formik.values.printerAssignments?.memoryMakerToDevice || {}
    const nextMemoryMakerToDevice = selectedMemoryMakers.reduce<Record<string, string>>((acc, memoryMaker) => {
      const memoryMakerUid = getMemoryMakerUid(memoryMaker)
      const legacyMemoryMakerId = getMemoryMakerLegacyId(memoryMaker)
      const assignedPrinterDeviceId =
        currentMemoryMakerToDevice[memoryMakerUid] || currentMemoryMakerToDevice[legacyMemoryMakerId]

      if (memoryMakerUid && assignedPrinterDeviceId && printerDeviceIds.includes(assignedPrinterDeviceId)) {
        acc[memoryMakerUid] = assignedPrinterDeviceId
      }

      return acc
    }, {})

    if (JSON.stringify(currentMemoryMakerToDevice) !== JSON.stringify(nextMemoryMakerToDevice)) {
      formik.setFieldValue('printerAssignments', {
        ...formik.values.printerAssignments,
        memoryMakerToDevice: nextMemoryMakerToDevice,
      }, false)
    }
  }, [
    formik.values.defaultPrinterDeviceId,
    formik.values.printerAssignments,
    selectedMemoryMakers,
    selectedPrinterDevices,
  ])

  const handlePrinterAssignmentChange = (memoryMakerId: string, printerDevice: DropdownOptions | null) => {
    const currentMemoryMakerToDevice = formik.values.printerAssignments?.memoryMakerToDevice || {}
    const nextMemoryMakerToDevice = {
      ...currentMemoryMakerToDevice,
    }

    if (printerDevice?.value) {
      nextMemoryMakerToDevice[memoryMakerId] = printerDevice.value
    } else {
      delete nextMemoryMakerToDevice[memoryMakerId]
    }

    formik.setFieldValue('printerAssignments', {
      ...formik.values.printerAssignments,
      memoryMakerToDevice: nextMemoryMakerToDevice,
    }, false)
  }

  const formatPrinterOptionLabel = (option: DropdownOptions, { context, selectValue }: any) => {
    const isSelectedInMenu =
      context === 'menu' &&
      selectValue &&
      selectValue.some((selectedOption: DropdownOptions) => selectedOption.value === option.value)

    return (
      <div className='d-flex flex-column'>
        <span className={isSelectedInMenu ? 'text-white' : 'text-gray-800 text-hover-primary fw-semibold'}>
          {option.label}
        </span>
        <span className={isSelectedInMenu ? 'text-white' : 'text-muted'}>{option.value}</span>
      </div>
    )
  }


  useEffect(() => {
    // Function to update the form value based on projectNo and startDate
    const updateFormValue = () => {
      const form = `https://yourstorywall.com/content/FRM-${formik.values.projectNo}-${removeSpaces(formik.values.parent[0].label, "-")}-${formik.values.startDate.toISOString().slice(0, -14)}`.toLocaleLowerCase();
      const micrositeBeta = `https://yourstorywall.com/content/DEV-${formik.values.projectNo}-${removeSpaces(formik.values.parent[0].label, "-")}-${formik.values.startDate.toISOString().slice(0, -14)}`.toLocaleLowerCase();
      const microsite = `SW_${formik.values.projectNo}_${formik.values.startDate.toISOString().slice(0, -14)}`.toLocaleLowerCase();
      const exportFolder = `SC_Export_${formik.values.projectNo}_${formik.values.startDate.toISOString().slice(0, -14)}`.toLocaleLowerCase();

      const dooh = `https://yourstorywall.com/content/DOOH-${formik.values.projectNo}-${formik.values.startDate.toISOString().slice(0, -14)}`.toLocaleLowerCase();

      const quitclaim = `https://yourstorywall.com/content/QC-${formik.values.projectNo}-${formik.values.startDate.toISOString().slice(0, -14)}`.toLocaleLowerCase();

      const intro = `https://yourstorywall.com/content/INFO-${formik.values.projectNo}-${formik.values.startDate.toISOString().slice(0, -14)}`.toLocaleLowerCase();

      if (formik.values.isIntro && !eventForEdit.intro) {
        formik.setFieldValue('intro', intro);
      }

      if (formik.values.isMicrosite && !eventForEdit.microsite) {
        formik.setFieldValue('microsite', microsite);
      }

      if (formik.values.isMicrosite && !eventForEdit.micrositeDate) {
        formik.setFieldValue('micrositeDate', startDate);
      }

      if (formik.values.isMicrosite && !eventForEdit.micrositeName) {
        formik.setFieldValue('micrositeName', formik.values.name);
      }

      if (formik.values.isMicrosite && !eventForEdit.micrositeBeta) {
        formik.setFieldValue('micrositeBeta', micrositeBeta);
      }

      if (formik.values.isForm && !eventForEdit.form) {
        formik.setFieldValue('form', form);
      }

      if (!eventForEdit.exportFolder) {
        formik.setFieldValue('exportFolder', exportFolder);
      }

      if (formik.values.isDooh && !eventForEdit.dooh) {
        formik.setFieldValue('dooh', dooh);
      }

      if (formik.values.isDooh && !eventForEdit.quitclaim) {
        formik.setFieldValue('quitclaim', quitclaim);
      }

    };

    // alert(formik.values.isRouter + " " + formik.values.isMicrosite)

    // Initial update when the component mounts
    updateFormValue();
  }, [formik.values.projectNo, formik.values.startDate, formik.values.name, formik.values.isDooh, formik.values.isMail, formik.values.isForm, formik.values.isMicrosite, formik.values.isIntro]); // Include dependencies if needed

  return (
    <>
      <form id='kt_modal_add_event_form' className='form' onSubmit={formik.handleSubmit} noValidate>
        {/* begin::Scroll */}
        <div
          className='d-flex flex-column scroll-y me-n7 pe-7'
          id='kt_modal_add_event_scroll'
          data-kt-scroll='true'
          data-kt-scroll-activate='{default: false, lg: true}'
          data-kt-scroll-max-height='auto'
          data-kt-scroll-dependencies='#kt_modal_add_event_header'
          data-kt-scroll-wrappers='#kt_modal_add_event_scroll'
          data-kt-scroll-offset='300px'
        >

          <div className='fv-row mb-7'>
            {/* begin::Label */}
            <label className='required fw-bold fs-6 mb-2'>Activation Id</label>
            {/* end::Label */}

            {/* begin::Input */}
            <div className='input-group' style={{ zIndex: 0 }}>
              <input
                placeholder='id'
                aria-disabled
                disabled={true}
                {...formik.getFieldProps('id')}
                type='text'
                name='id'
                className={clsx(
                  'form-control form-control-solid mb-3 mb-lg-0',
                  { 'is-invalid': formik.touched.id && formik.errors.id },
                  { 'is-valid': formik.touched.id && !formik.errors.id }
                )}
                autoComplete='off'
              />
              <button
                className='btn btn-primary'
                type='button'
                disabled={formik.isSubmitting || isEventLoading}
                onClick={() => {
                  copyToClipboard(formik.values.id)
                }}
              >
                Copy
              </button>
            </div>
            {/* end::Input */}

            {formik.touched.id && formik.errors.id && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.id}</span>
                </div>
              </div>
            )}
          </div>

          {/* begin::Input group */}
          <div className='fv-row mb-7'>
            {/* begin::Label */}
            <label className='d-block fw-bold fs-6 mb-5'>Avatar</label>
            {/* end::Label */}

            {/* begin::Image input */}
            <div
              // className='image-input image-input-outline'
              className='image-input'
              data-kt-image-input='true'
              style={{ backgroundImage: `url('${blankImg}')` }}
            >
              {/* begin::Preview existing avatar */}
              {/* <div
                className='image-input-wrapper w-125px h-125px'
                style={{ backgroundImage: `url('${avatar.display ? avatar.display : eventForEdit.avatar}')` }}
              ></div> */}
              <img
                className='image-input-wrapper'
                src={avatar.display ? avatar.display : eventForEdit.avatar ? eventForEdit.avatar : toAbsoluteUrl('/media/svg/files/blank-image-dark.svg')}
                alt='Image Alt Text'
                style={{
                  width: '100%',
                  height: '150px',
                }}
              />
              {/* end::Preview existing avatar */}

              {/* begin::Label */}
              <label
                className='btn btn-icon  btn-active-color-primary w-25px h-25px bg-body shadow'
                data-kt-image-input-action='change'
                data-bs-toggle='tooltip'
                title='Change avatar'
              >
                {/* <i className='bi bi-pencil-fill fs-7'></i> */}

                <input type='file'
                  onChange={handleChange}
                  name='avatar' accept='.png, .jpg, .jpeg' />
                {/* <input type='hidden' name='avatar_remove' /> */}
              </label>
              {/* end::Label */}
            </div>
            {/* end::Image input */}
          </div>
          {/* end::Input group */}

          {/* begin::Input group */}
          <div className='fv-row mb-7'>
            {/* begin::Label */}
            <label className='required fw-bold fs-6 mb-2'>Activation Title</label>
            {/* end::Label */}

            {/* begin::Input */}
            <input
              placeholder='Activation Title'
              {...formik.getFieldProps('name')}
              type='text'
              name='name'
              className={clsx(
                'form-control form-control-solid mb-3 mb-lg-0',
                { 'is-invalid': formik.touched.name && formik.errors.name },
                {
                  'is-valid': formik.touched.name && !formik.errors.name,
                }
              )}
              autoComplete='off'
              disabled={formik.isSubmitting || isEventLoading}
            />
            {formik.touched.name && formik.errors.name && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.name}</span>
                </div>
              </div>
            )}
            {/* end::Input */}
          </div>
          {/* end::Input group */}


          <div className='fv-row mb-7'>
            {/* begin::Label */}
            <label className='fw-bold fs-6 mb-2'>Project #</label>
            {/* end::Label */}

            {/* begin::Input */}
            <input
              placeholder='Project #'
              {...formik.getFieldProps('projectNo')}
              type='text'
              name='projectNo'
              className={clsx(
                'form-control form-control-solid mb-3 mb-lg-0',
              )}
              autoComplete='off'
              disabled={formik.isSubmitting || isEventLoading}
            />
            {/* end::Input */}
          </div>

          <div className='fv-row mb-7'>
            {/* begin::Label */}
            <label className=' fw-bold fs-6 mb-2'>Tags</label>
            {/* end::Label */}

            {/* begin::Input */}
            <div
              className='px-2'
              onClick={(event) => {
                event.stopPropagation();
              }}>

              <CreatableSelect
                // value={value}
                {...formik.getFieldProps('tags')}
                placeholder="Type to Choose or Create"
                hideSelectedOptions={false}
                onChange={(newValue) => {
                  formik.setFieldValue('tags', newValue, false)
                }}
                backspaceRemovesValue={false}
                blurInputOnSelect={false}
                className='fs-6'
                // text-uppercase 
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 0,
                  colors: {
                    ...theme.colors,
                  },
                })}
                isMulti={true}
                styles={{
                  option: (base, state) => ({
                    ...base,
                  }),
                  multiValue: (styles, { data }) => {
                    return {
                      ...styles,
                      borderRadius: 10,
                      backgroundColor: '#432cffb8',
                      padding: 4,
                      margin: 4,
                      color: 'white',
                      boxShadow: '#0303030f 0px 0px 20px 0px'
                    };
                  },
                  multiValueLabel: (styles, { data }) => ({
                    ...styles,
                    fontWeight: 'bold',
                    color: 'white'

                  }),
                  multiValueRemove: (styles, { data }) => ({
                    ...styles,
                    ':hover': {
                      color: 'gray',
                    },
                  }),
                  control: (base) => ({
                    ...base,
                    // backgroundColor: var(--kt-input-solid-bg),
                    // zIndex: 9999,
                    padding: "5px",
                    border: "none",
                    borderRadius: 10,
                    boxShadow: '#3d88a614 0px 0px 20px 0px'
                    // boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 50px'
                    // boxShadow: "0 0 50px 0 rgb(82 63 105 / 15%)",
                  }),
                  menu: (base) => ({
                    ...base,
                    // zIndex: 19999,
                    backgroundColor: "white",
                    padding: "10px",
                    border: "none",
                    borderRadius: 10,
                    boxShadow: '#3d88a614 0px 0px 20px 0px'
                    // boxShadow: 'rgba(0, 0, 0, 0.07) -4px 9px 25px -6px'
                    // boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 50px',
                    // boxShadow: "0 0 50px 0 rgb(82 63 105 / 15%)",
                  }),
                  singleValue: (base) => ({ ...base, color: "#000", borderRadius: 10, }),
                }}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                name="color"
                options={dropdownOptions}
              />
              {formik.touched.tags && formik.errors.tags && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.tags}</span>
                  </div>
                </div>
              )}
            </div>
            {/* end::Input */}
          </div>


          {/* begin::Input group */}
          <div className='fv-row mb-0'>
            {/* begin::Label */}
            <label className=' fw-bold fs-6 mb-2'>Extra Info</label>
            {/* end::Label */}

            {/* begin::Input */}
            <textarea
              className='form-control form-control-solid mb-8'
              rows={3}
              placeholder='Add extra info here'
              {...formik.getFieldProps('info')}
              name='info'
              autoComplete='off'
              disabled={formik.isSubmitting || isEventLoading}
            ></textarea>
            {/* end::Input */}
          </div>
          {/* end::Input group */}


          {/* begin::Input group */}
          <div className='fv-row mb-7'>
            <label className='required fw-bold fs-6 mb-2'>Start Date</label>
            <DatePicker showPopperArrow={false}
              className={clsx(
                'form-control form-control-solid mb-3 mb-lg-0',
                { 'is-invalid': formik.touched.startDate && formik.errors.startDate },
                {
                  'is-valid': formik.touched.startDate && !formik.errors.startDate,
                }
              )}
              // minDate={new Date()}
              selected={formik.values.startDate}
              onChange={(startDate) => {
                formik.setFieldValue('startDate', startDate, false)
                if (formik.values.isMicrosite) {
                  formik.setFieldValue('micrositeDate', startDate, false)
                }
                setStartDate(startDate)
                formik.setFieldValue('endDate', addDaysToDate(startDate, 1))
                setEndDate(addDaysToDate(startDate, 1))
              }}
              showTimeSelect={true}
              timeFormat="HH:mm"
              dateFormat={"HH:mm MMMM d, yyyy"}
            />
            {/* {formik.touched.startDate && formik.errors.startDate && (
              <div className='fv-plugins-message-container'>
                <span role='alert'>{formik.errors.startDate}</span>
              </div>
            )} */}
          </div>
          {/* end::Input group */}

          {/* begin::Input group */}
          <div className='fv-row mb-7'>
            <label className='required fw-bold fs-6 mb-2'>End Date</label>
            <DatePicker
              showPopperArrow={false}
              className={clsx(
                'form-control form-control-solid mb-3 mb-lg-0',
                { 'is-invalid': formik.touched.endDate && formik.errors.endDate },
                {
                  'is-valid': formik.touched.endDate && !formik.errors.endDate,
                }
              )}
              minDate={formik.values.startDate}
              selected={formik.values.endDate}
              onChange={(endDate) => {
                formik.setFieldValue('endDate', endDate)
                setEndDate(endDate)
              }}
              showTimeSelect={true}
              maxDate={addDaysToDate(formik.values.startDate, 1)}
              timeFormat="HH:mm"
              dateFormat={"HH:mm MMMM d, yyyy"}
            />
          </div>
          {/* end::Input group */}

          <div className='fv-row mb-7'>
            {/* begin::Label */}
            <label className=' fw-bold fs-6 mb-2'>Owner</label>
            {/* end::Label */}

            {/* begin::Input */}
            <div
              className='px-2'
              onClick={(event) => {
                event.stopPropagation();
              }}>

              <ReactSelect
                // value={value}
                {...formik.getFieldProps('parent')}
                placeholder="Tap or Search"
                hideSelectedOptions={false}
                // onChange={(newValue) => {
                //   formik.setFieldValue('parent', newValue, false)
                // }}
                filterOption={(option, rawInput) => {
                  let searchArray = [...option.data.tags];  // Use the spread operator to clone the array
                  searchArray.push(option.label.toLowerCase());
                  searchArray.push(option.value.toLowerCase());

                  const matchingStrings = searchArray.filter((str) => str.includes(rawInput));
                  return matchingStrings.length > 0;  // Simplified the return statement
                }
                }
                backspaceRemovesValue={false}
                blurInputOnSelect={false}
                className=' fs-6'
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 0,
                  colors: {
                    ...theme.colors,
                  },
                })}
                isMulti={true}
                styles={{
                  option: (base, state) => ({
                    ...base,
                  }),
                  multiValue: (styles, { data }) => {
                    return {
                      ...styles,
                      borderRadius: 10,
                      backgroundColor: data.archive ? '#7239ea73  ' : '#432cffb8',
                      padding: 4,
                      margin: 4,
                      color: 'white',
                      boxShadow: '#0303030f 0px 0px 20px 0px'
                    };
                  },
                  multiValueLabel: (styles, { data }) => ({
                    ...styles,
                    fontWeight: 'bold',
                    color: 'white'

                  }),
                  multiValueRemove: (styles, { data }) => ({
                    ...styles,
                    ':hover': {
                      color: 'gray',
                    },
                  }),
                  control: (base) => ({
                    ...base,
                    // backgroundColor: var(--kt-input-solid-bg),
                    // zIndex: 9999,
                    padding: "5px",
                    border: "none",
                    borderRadius: 10,
                    boxShadow: '#3d88a614 0px 0px 20px 0px'
                    // boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 50px'
                    // boxShadow: "0 0 50px 0 rgb(82 63 105 / 15%)",
                  }),
                  menu: (base) => ({
                    ...base,
                    // zIndex: 19999,
                    backgroundColor: "white",
                    padding: "10px",
                    border: "none",
                    borderRadius: 10,
                    boxShadow: '#3d88a614 0px 0px 20px 0px'
                    // boxShadow: 'rgba(0, 0, 0, 0.07) -4px 9px 25px -6px'
                    // boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 50px',
                    // boxShadow: "0 0 50px 0 rgb(82 63 105 / 15%)",
                  }),
                  singleValue: (base) => ({ ...base, color: "#000", borderRadius: 10, }),
                }}

                formatOptionLabel={(option, { selectValue }) => {
                  const isSelected = selectValue && selectValue.some((selectedOption) => selectedOption.value === option.value);

                  return (
                    <div className='d-flex align-items-center'>
                      <div className='symbol symbol-oval symbol-40px overflow-hidden me-3'>
                        <a href='#'>
                          {option.avatar ? (
                            <div className='symbol-label'>
                              <img src={option.avatar} alt={option.label} className='w-100' />
                            </div>
                          ) : (
                            <div
                              className={clsx(
                                'symbol-label fs-3',
                                `bg-light-${option.label}`,
                                `text-${option.label}`
                              )}
                            >
                              {option.label?.[0]}
                            </div>
                          )}
                        </a>
                      </div>
                      <div className='d-flex flex-column'>
                        <a href='#' className={isSelected ? 'text-white' : 'text-gray-800 text-hover-primary mb-1'}>
                          {option.label}
                        </a>
                        <span style={{ color: 'black' }}>{option.email}</span>
                      </div>
                    </div>
                  );
                }}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                name="color"
              />
              {formik.touched.tags && formik.errors.tags && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.tags}</span>
                  </div>
                </div>
              )}
            </div>
            {/* end::Input */}
          </div>

          <div className='fv-row mb-7'>
            {/* begin::Label */}
            <label className=' fw-bold fs-6 mb-2'>Shared Clients</label>
            {/* end::Label */}

            {/* begin::Input */}
            <div
              className='px-2'
              onClick={(event) => {
                event.stopPropagation();
              }}>

              <ReactSelect
                // value={value}
                {...formik.getFieldProps('clients')}
                placeholder="Tap or Search"
                hideSelectedOptions={false}
                onChange={(newValue) => {
                  formik.setFieldValue('clients', newValue, false)
                }}
                filterOption={(option, rawInput) => {
                  let searchArray = [...option.data.tags];  // Use the spread operator to clone the array
                  searchArray.push(option.label.toLowerCase());
                  searchArray.push(option.value.toLowerCase());

                  const matchingStrings = searchArray.filter((str) => str.includes(rawInput));
                  return matchingStrings.length > 0;  // Simplified the return statement
                }
                }
                backspaceRemovesValue={false}
                blurInputOnSelect={false}
                className=' fs-6'
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 0,
                  colors: {
                    ...theme.colors,
                  },
                })}
                isMulti={true}
                styles={{
                  option: (base, state) => ({
                    ...base,
                  }),
                  multiValue: (styles, { data }) => {
                    return {
                      ...styles,
                      borderRadius: 10,
                      backgroundColor: data.archive ? '#7239ea73  ' : '#432cffb8',
                      padding: 4,
                      margin: 4,
                      color: 'white',
                      boxShadow: '#0303030f 0px 0px 20px 0px'
                    };
                  },
                  multiValueLabel: (styles, { data }) => ({
                    ...styles,
                    fontWeight: 'bold',
                    color: 'white'

                  }),
                  multiValueRemove: (styles, { data }) => ({
                    ...styles,
                    ':hover': {
                      color: 'gray',
                    },
                  }),
                  control: (base) => ({
                    ...base,
                    // backgroundColor: var(--kt-input-solid-bg),
                    // zIndex: 9999,
                    padding: "5px",
                    border: "none",
                    borderRadius: 10,
                    boxShadow: '#3d88a614 0px 0px 20px 0px'
                    // boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 50px'
                    // boxShadow: "0 0 50px 0 rgb(82 63 105 / 15%)",
                  }),
                  menu: (base) => ({
                    ...base,
                    // zIndex: 19999,
                    backgroundColor: "white",
                    padding: "10px",
                    border: "none",
                    borderRadius: 10,
                    boxShadow: '#3d88a614 0px 0px 20px 0px'
                    // boxShadow: 'rgba(0, 0, 0, 0.07) -4px 9px 25px -6px'
                    // boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 50px',
                    // boxShadow: "0 0 50px 0 rgb(82 63 105 / 15%)",
                  }),
                  singleValue: (base) => ({ ...base, color: "#000", borderRadius: 10, }),
                }}

                formatOptionLabel={(option, { selectValue }) => {
                  const isSelected = selectValue && selectValue.some((selectedOption) => selectedOption.value === option.value);

                  return (
                    <div className='d-flex align-items-center'>
                      <div className='symbol symbol-oval symbol-40px overflow-hidden me-3'>
                        <a href='#'>
                          {option.avatar ? (
                            <div className='symbol-label'>
                              <img src={option.avatar} alt={option.label} className='w-100' />
                            </div>
                          ) : (
                            <div
                              className={clsx(
                                'symbol-label fs-3',
                                `bg-light-${option.label}`,
                                `text-${option.label}`
                              )}
                            >
                              {option.label?.[0]}
                            </div>
                          )}
                        </a>
                      </div>
                      <div className='d-flex flex-column'>
                        <a href='#' className={isSelected ? 'text-white' : 'text-gray-800 text-hover-primary mb-1'}>
                          {option.label}
                        </a>
                        <span style={{ color: 'black' }}>{option.email}</span>
                      </div>
                    </div>
                  );
                }}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                name="color"
                options={clients.filter((item, index) => {
                  if (
                    containsId(event.parent, item.value)
                  ) {
                    return false
                  }
                  else {
                    return true
                  }
                })}
              />
              {formik.touched.tags && formik.errors.tags && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.tags}</span>
                  </div>
                </div>
              )}
            </div>
            {/* end::Input */}
          </div>

          <div className='fv-row mb-7'>
            {/* begin::Label */}
            <label className=' fw-bold fs-6 mb-2'>Memory Makers</label>
            {/* end::Label */}

            {/* begin::Input */}
            <div
              className='px-2'
              onClick={(event) => {
                event.stopPropagation();
              }}>

              <ReactSelect
                // value={value}
                {...formik.getFieldProps('memoryMakers')}
                placeholder="Tap or Search"
                hideSelectedOptions={false}
                onChange={(newValue) => {
                  formik.setFieldValue('memoryMakers', newValue, false)
                }}
                backspaceRemovesValue={false}
                blurInputOnSelect={false}
                className=' fs-6'
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 0,
                  colors: {
                    ...theme.colors,
                  },
                })}

                isMulti={true}
                styles={{
                  option: (base, state) => ({
                    ...base,
                  }),
                  multiValue: (styles, { data }) => {
                    return {
                      ...styles,
                      borderRadius: 10,
                      backgroundColor: data.archive ? '#7239ea73  ' : '#432cffb8',
                      padding: 4,
                      margin: 4,
                      color: 'white',
                      boxShadow: '#0303030f 0px 0px 20px 0px'
                    };
                  },
                  multiValueLabel: (styles, { data }) => ({
                    ...styles,
                    fontWeight: 'bold',
                    color: 'white'

                  }),
                  multiValueRemove: (styles, { data }) => ({
                    ...styles,
                    ':hover': {
                      color: 'gray',
                    },
                  }),
                  control: (base) => ({
                    ...base,
                    // backgroundColor: var(--kt-input-solid-bg),
                    // zIndex: 9999,
                    padding: "5px",
                    border: "none",
                    borderRadius: 10,
                    boxShadow: '#3d88a614 0px 0px 20px 0px'
                    // boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 50px'
                    // boxShadow: "0 0 50px 0 rgb(82 63 105 / 15%)",
                  }),
                  menu: (base) => ({
                    ...base,
                    // zIndex: 19999,
                    backgroundColor: "white",
                    padding: "10px",
                    border: "none",
                    borderRadius: 10,
                    boxShadow: '#3d88a614 0px 0px 20px 0px'
                    // boxShadow: 'rgba(0, 0, 0, 0.07) -4px 9px 25px -6px'
                    // boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 50px',
                    // boxShadow: "0 0 50px 0 rgb(82 63 105 / 15%)",
                  }),
                  singleValue: (base) => ({ ...base, color: "#000", borderRadius: 10, }),
                }}

                formatOptionLabel={(option, { selectValue }) => {
                  const isSelected = selectValue && selectValue.some((selectedOption) => selectedOption.value === option.value);

                  return (
                    <div className='d-flex align-items-center'>
                      <div className='symbol symbol-oval symbol-40px overflow-hidden me-3'>
                        <a href='#'>
                          {option.avatar ? (
                            <div className='symbol-label'>
                              <img src={option.avatar} alt={option.label} className='w-100' />
                            </div>
                          ) : (
                            <div
                              className={clsx(
                                'symbol-label fs-3',
                                `bg-light-${option.label}`,
                                `text-${option.label}`
                              )}
                            >
                              {option.label?.[0]}
                            </div>
                          )}
                        </a>
                      </div>
                      <div className='d-flex flex-column'>
                        <a href='#' className={isSelected ? 'text-white' : 'text-gray-800 text-hover-primary mb-1'}>
                          {option.label}
                        </a>
                        <span style={{ color: 'black' }}>{option.email}</span>
                      </div>
                    </div>
                  );
                }}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                name="color"
                options={memoryMakers}
              />
              {formik.touched.tags && formik.errors.tags && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.tags}</span>
                  </div>
                </div>
              )}
            </div>
            {/* end::Input */}
          </div>


          <div className='fv-row mb-7'>
            <label className=' fw-bold fs-6 mb-2'>Printer Devices</label>

            <div
              className='px-2'
              onClick={(event) => {
                event.stopPropagation();
              }}>

              <ReactSelect
                {...formik.getFieldProps('printerDevices')}
                value={selectedPrinterDevices}
                placeholder="Tap or Search"
                hideSelectedOptions={false}
                onChange={(newValue) => {
                  formik.setFieldValue('printerDevices', newValue || [], false)
                }}
                backspaceRemovesValue={false}
                blurInputOnSelect={false}
                className=' fs-6'
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 0,
                  colors: {
                    ...theme.colors,
                  },
                })}
                isMulti={true}
                styles={compactSelectStyles}
                formatOptionLabel={formatPrinterOptionLabel}
                isDisabled={formik.isSubmitting || isEventLoading}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                name="printerDevices"
                options={printerDevices}
              />
            </div>
          </div>

          <div className='fv-row mb-7'>
            <label className=' fw-bold fs-6 mb-2'>Default Printer Device</label>

            <div
              className='px-2'
              onClick={(event) => {
                event.stopPropagation();
              }}>

              <ReactSelect
                value={selectedDefaultPrinterDevice}
                placeholder="Tap or Search"
                hideSelectedOptions={false}
                onChange={(newValue) => {
                  formik.setFieldValue('defaultPrinterDeviceId', (newValue as DropdownOptions | null)?.value || '', false)
                }}
                backspaceRemovesValue={false}
                blurInputOnSelect={false}
                className=' fs-6'
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 0,
                  colors: {
                    ...theme.colors,
                  },
                })}
                styles={compactSelectStyles}
                formatOptionLabel={formatPrinterOptionLabel}
                isDisabled={formik.isSubmitting || isEventLoading || selectedPrinterDevices.length === 0}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                name="defaultPrinterDeviceId"
                options={selectedPrinterDevices}
              />
            </div>
          </div>

          <div className='fv-row mb-7'>
            <label className=' fw-bold fs-6 mb-2'>Printer Assignments</label>

            <div className='px-2'>
              {selectedMemoryMakers.length > 0 && selectedPrinterDevices.length > 0 ? (
                selectedMemoryMakers.map((memoryMaker) => {
                  const memoryMakerUid = getMemoryMakerUid(memoryMaker)
                  const legacyMemoryMakerId = getMemoryMakerLegacyId(memoryMaker)
                  const assignedPrinterDeviceId =
                    formik.values.printerAssignments?.memoryMakerToDevice?.[memoryMakerUid] ||
                    formik.values.printerAssignments?.memoryMakerToDevice?.[legacyMemoryMakerId]
                  const assignedPrinterDevice = selectedPrinterDevices.find(
                    (printerDevice) => printerDevice.value === assignedPrinterDeviceId
                  ) || null

                  return (
                    <div
                      key={memoryMakerUid || legacyMemoryMakerId}
                      className='d-flex align-items-center flex-wrap gap-3 mb-4'
                    >
                      <div className='min-w-200px flex-grow-1'>
                        <div className='fw-bold text-gray-800 text-truncate'>{memoryMaker.label}</div>
                        <div className='text-muted fs-7 text-truncate'>{memoryMakerUid}</div>
                      </div>
                      <div className='flex-grow-1 min-w-250px'>
                        <ReactSelect
                          value={assignedPrinterDevice}
                          placeholder="Tap or Search"
                          hideSelectedOptions={false}
                          onChange={(newValue) => {
                            handlePrinterAssignmentChange(memoryMakerUid, newValue as DropdownOptions | null)
                          }}
                          backspaceRemovesValue={false}
                          blurInputOnSelect={false}
                          className='fs-6'
                          theme={(theme) => ({
                            ...theme,
                            borderRadius: 0,
                            colors: {
                              ...theme.colors,
                            },
                          })}
                          styles={compactSelectStyles}
                          formatOptionLabel={formatPrinterOptionLabel}
                          isDisabled={formik.isSubmitting || isEventLoading}
                          isLoading={false}
                          isClearable={true}
                          isRtl={false}
                          isSearchable={true}
                          name={`printerAssignment_${memoryMakerUid || legacyMemoryMakerId}`}
                          options={selectedPrinterDevices}
                        />
                      </div>
                    </div>
                  )
                })
              ) : (
                <div className='text-muted fw-semibold fs-7'>No assignments available</div>
              )}
            </div>
          </div>



          <div className='fv-row mb-7'>
            {/* begin::Label */}
            <label className='required fw-bold fs-6 mb-2'>Export Folder (CameraRoll)</label>
            {/* end::Label */}

            {/* begin::Input */}
            <input
              placeholder='KNVB_SAYCHEESE'
              {...formik.getFieldProps('exportFolder')}
              type='text'
              // defaultValue={("SC_Export_" + formik.values.projectNo + "_" + new Date(formik.values.startDate).toISOString().slice(0, -14)).toLocaleLowerCase()}
              name='exportFolder'
              className={clsx(
                'form-control form-control-solid mb-3 mb-lg-0',
                { 'is-invalid': formik.touched.exportFolder && formik.errors.exportFolder },
                {
                  'is-valid': formik.touched.exportFolder && !formik.errors.exportFolder,
                }
              )}
              autoComplete='off'
              disabled={formik.isSubmitting || isEventLoading}
            />
            {formik.touched.exportFolder && formik.errors.exportFolder && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.exportFolder}</span>
                </div>
              </div>
            )}
            {/* end::Input */}
          </div>
          {/* end::Input group */}

          <div className='fv-row mb-7'>
            {/* begin::Label */}
            <label className=' fw-bold fs-6 mb-2'>Templates</label>
            {/* end::Label */}

            {/* begin::Input */}
            <div
              className='px-2'
              onClick={(event) => {
                event.stopPropagation();
              }}>

              <ReactSelect
                // value={value}
                {...formik.getFieldProps('templates')}
                placeholder="Tap or Search"
                hideSelectedOptions={false}
                onChange={(newValue) => {
                  formik.setFieldValue('templates', newValue, false)
                }}
                filterOption={(option, rawInput) => {
                  let searchArray = [...option.data.tags];  // Use the spread operator to clone the array
                  searchArray.push(option.label.toLowerCase());
                  searchArray.push(option.value.toLowerCase());

                  const matchingStrings = searchArray.filter((str) => str.includes(rawInput));
                  return matchingStrings.length > 0;  // Simplified the return statement
                }
                  // customFilter(option, rawInput, option => option.value)
                }
                backspaceRemovesValue={false}
                blurInputOnSelect={false}
                className=' fs-6'
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 0,
                  colors: {
                    ...theme.colors,
                  },
                })}
                isMulti={true}
                styles={{
                  option: (base, state) => ({
                    ...base,
                  }),
                  multiValue: (styles, { data }) => {
                    return {
                      ...styles,
                      borderRadius: 10,
                      backgroundColor: data.archive ? '#7239ea73  ' : '#432cffb8',
                      padding: 4,
                      margin: 4,
                      color: 'white',
                      boxShadow: '#0303030f 0px 0px 20px 0px'
                    };
                  },
                  multiValueLabel: (styles, { data }) => ({
                    ...styles,
                    fontWeight: 'bold',
                    color: 'white'

                  }),
                  multiValueRemove: (styles, { data }) => ({
                    ...styles,
                    ':hover': {
                      color: 'gray',
                    },
                  }),
                  control: (base) => ({
                    ...base,
                    // backgroundColor: var(--kt-input-solid-bg),
                    // zIndex: 9999,
                    padding: "5px",
                    border: "none",
                    borderRadius: 10,
                    boxShadow: '#3d88a614 0px 0px 20px 0px'
                    // boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 50px'
                    // boxShadow: "0 0 50px 0 rgb(82 63 105 / 15%)",
                  }),
                  menu: (base) => ({
                    ...base,
                    // zIndex: 19999,
                    backgroundColor: "white",
                    padding: "10px",
                    border: "none",
                    borderRadius: 10,
                    boxShadow: '#3d88a614 0px 0px 20px 0px'
                    // boxShadow: 'rgba(0, 0, 0, 0.07) -4px 9px 25px -6px'
                    // boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 50px',
                    // boxShadow: "0 0 50px 0 rgb(82 63 105 / 15%)",
                  }),
                  singleValue: (base) => ({ ...base, color: "#000", borderRadius: 10, }),
                }}

                formatOptionLabel={(option, { selectValue }) => {
                  const isSelected = selectValue && selectValue.some((selectedOption) => selectedOption.value === option.value);
                  return (
                    <div className='d-flex align-items-center'>
                      <div className='symbol symbol-oval symbol-40px overflow-hidden me-3'>
                        <a href='#'>
                          {option.avatar ? (
                            <div className='symbol-label'>
                              <img src={option.avatar} alt={option.label} className='w-100' />
                            </div>
                          ) : (
                            <div
                              className={clsx(
                                'symbol-label fs-3',
                                `bg-light-${option.label}`,
                                `text-${option.label}`
                              )}
                            >
                              {option.label?.[0]}
                            </div>
                          )}
                        </a>
                      </div>
                      <div className='d-flex flex-column'>
                        <a href='#' className={isSelected ? 'text-white' : 'text-gray-800 text-hover-primary mb-1'}>
                          {option.label}
                        </a>
                        <span style={{ color: 'black' }}>{option.email}</span>
                      </div>
                    </div>
                  );
                }}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                name="color"
                options={templates}
              />
              {formik.touched.tags && formik.errors.tags && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.tags}</span>
                  </div>
                </div>
              )}
            </div>
            {/* end::Input */}
          </div>


          <div className='fv-row mb-7'>
            {/* begin::Label */}
            <label className=' fw-bold fs-6 mb-2'>Frames</label>
            {/* end::Label */}

            {/* begin::Input */}
            <div
              className='px-2'
              onClick={(event) => {
                event.stopPropagation();
              }}>

              <ReactSelect
                // value={value}
                {...formik.getFieldProps('frames')}
                placeholder="Tap or Search"
                hideSelectedOptions={false}
                onChange={(newValue) => {
                  formik.setFieldValue('frames', newValue, false)
                }}
                filterOption={(option, rawInput) => {
                  let searchArray = [...option.data.tags];  // Use the spread operator to clone the array
                  searchArray.push(option.label.toLowerCase());
                  searchArray.push(option.value.toLowerCase());

                  const matchingStrings = searchArray.filter((str) => str.includes(rawInput));
                  return matchingStrings.length > 0;  // Simplified the return statement
                }
                  // customFilter(option, rawInput, option => option.value)
                }
                backspaceRemovesValue={false}
                blurInputOnSelect={false}
                className=' fs-6'
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 0,
                  colors: {
                    ...theme.colors,
                  },
                })}
                isMulti={true}
                styles={{
                  option: (base, state) => ({
                    ...base,
                  }),
                  multiValue: (styles, { data }) => {
                    return {
                      ...styles,
                      borderRadius: 10,
                      backgroundColor: data.archive ? '#7239ea73  ' : '#432cffb8',
                      padding: 4,
                      margin: 4,
                      color: 'white',
                      boxShadow: '#0303030f 0px 0px 20px 0px'
                    };
                  },
                  multiValueLabel: (styles, { data }) => ({
                    ...styles,
                    fontWeight: 'bold',
                    color: 'white'

                  }),
                  multiValueRemove: (styles, { data }) => ({
                    ...styles,
                    ':hover': {
                      color: 'gray',
                    },
                  }),
                  control: (base) => ({
                    ...base,
                    // backgroundColor: var(--kt-input-solid-bg),
                    // zIndex: 9999,
                    padding: "5px",
                    border: "none",
                    borderRadius: 10,
                    boxShadow: '#3d88a614 0px 0px 20px 0px'
                    // boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 50px'
                    // boxShadow: "0 0 50px 0 rgb(82 63 105 / 15%)",
                  }),
                  menu: (base) => ({
                    ...base,
                    // zIndex: 19999,
                    backgroundColor: "white",
                    padding: "10px",
                    border: "none",
                    borderRadius: 10,
                    boxShadow: '#3d88a614 0px 0px 20px 0px'
                    // boxShadow: 'rgba(0, 0, 0, 0.07) -4px 9px 25px -6px'
                    // boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 50px',
                    // boxShadow: "0 0 50px 0 rgb(82 63 105 / 15%)",
                  }),
                  singleValue: (base) => ({ ...base, color: "#000", borderRadius: 10, }),
                }}

                formatOptionLabel={(option, { selectValue }) => {
                  const isSelected = selectValue && selectValue.some((selectedOption) => selectedOption.value === option.value);
                  return (
                    <div className='d-flex align-items-center'>
                      <div className='symbol symbol-oval symbol-40px overflow-hidden me-3'>
                        <a href='#'>
                          {option.avatar ? (
                            <div className='symbol-label'>
                              <img src={option.avatar} alt={option.label} className='w-100' />
                            </div>
                          ) : (
                            <div
                              className={clsx(
                                'symbol-label fs-3',
                                `bg-light-${option.label}`,
                                `text-${option.label}`
                              )}
                            >
                              {option.label?.[0]}
                            </div>
                          )}
                        </a>
                      </div>
                      <div className='d-flex flex-column'>
                        <a href='#' className={isSelected ? 'text-white' : 'text-gray-800 text-hover-primary mb-1'}>
                          {option.label}
                        </a>
                        <span style={{ color: 'black' }}>{option.email}</span>
                      </div>
                    </div>
                  );
                }}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                name="color"
                options={frames}
              />
              {formik.touched.tags && formik.errors.tags && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.tags}</span>
                  </div>
                </div>
              )}
            </div>
            {/* end::Input */}
          </div>


          <div className='mb-7'>
            <label className='required fw-bold fs-6 mb-5'>Initial Tool Frame</label>
            <div className='d-flex fv-row'>
              <RadioInput
                formik={formik}
                name='initialToolFrame'
                label='Yes'
                value={true}
                id='kt_modal_update_activation_initial_tool_frame_yes'
                isTemplateLoading={isEventLoading}
              />
            </div>
            <div className='separator separator-dashed my-5'></div>
            <div className='d-flex fv-row'>
              <RadioInput
                formik={formik}
                name='initialToolFrame'
                label='No'
                value={false}
                id='kt_modal_update_activation_initial_tool_frame_no'
                isTemplateLoading={isEventLoading}
              />
            </div>
            <div className='separator separator-dashed my-5'></div>
          </div>


          <div className='mb-7'>
            <label className='required fw-bold fs-6 mb-5'>QR Cards</label>
            <div className='d-flex fv-row'>
              <RadioInput
                formik={formik}
                name='qrCards'
                label='Yes'
                value={true}
                id='kt_modal_update_role_option_0'
                isTemplateLoading={isEventLoading}
              />
            </div>
            <div className='separator separator-dashed my-5'></div>
            <div className='d-flex fv-row'>
              <RadioInput
                formik={formik}
                name='qrCards'
                label='No'
                value={false}
                id='kt_modal_update_role_option_1'
                isTemplateLoading={isEventLoading}
              />
            </div>
            <div className='separator separator-dashed my-5'></div>
          </div>

          <div className='mb-7'>
            <label className='required fw-bold fs-6 mb-5'>Form</label>
            <div className='d-flex fv-row'>
              <RadioInput
                formik={formik}
                name='isForm'
                label='Yes'
                value={true}
                id='kt_modal_update_role_option_0'
                isTemplateLoading={isEventLoading}
              />
            </div>
            <div className='separator separator-dashed my-5'></div>
            <div className='d-flex fv-row'>
              <RadioInput
                formik={formik}
                name='isForm'
                label='No'
                value={false}
                id='kt_modal_update_role_option_1'
                isTemplateLoading={isEventLoading}
              />
            </div>
            <div className='separator separator-dashed my-5'></div>
          </div>

          {
            formik.values.isForm && (
              <div className='fv-row mb-7'>
                {/* begin::Label */}
                <label className='required fw-bold fs-6 mb-2'>Form</label>
                {/* end::Label */}

                {/* begin::Input */}
                <div className='input-group' style={{ zIndex: 0 }}>
                  <input
                    placeholder='https://yourstorywall.com/content/FRM'
                    {...formik.getFieldProps('form')}
                    type='text'
                    // defaultValue={("https://yourstorywall.com/content/FRM_" + formik.values.projectNo + "_" + removeSpaces(formik.values.parent[0].label) + "_" + formik.values.startDate.toISOString().slice(0, -14)).toLocaleLowerCase()}
                    name='form'
                    className={clsx(
                      'form-control form-control-solid mb-3 mb-lg-0',
                      { 'is-invalid': formik.touched.form && formik.errors.form },
                      { 'is-valid': formik.touched.form && !formik.errors.form }
                    )}
                    autoComplete='off'
                    disabled={formik.isSubmitting || isEventLoading}
                  />
                  <button
                    className='btn btn-primary'
                    type='button'
                    onClick={() => {
                      copyToClipboard(formik.values.form);
                      // Optionally, provide feedback to the user that the text has been copied.
                      // Example: alert('Copied to clipboard!');
                    }}
                    disabled={formik.isSubmitting || isEventLoading}
                  >
                    Copy
                  </button>
                </div>
                {/* end::Input */}

                {formik.touched.form && formik.errors.form && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.form}</span>
                    </div>
                  </div>
                )}
              </div>
            )
          }

          {
            formik.values.isForm && (
              <div className='fv-row mb-7'>
                {/* begin::Label */}
                <label className='required fw-bold fs-6 mb-2'>QR Mail Id</label>
                {/* end::Label */}

                {/* begin::Input */}
                <div className='input-group' style={{ zIndex: 0 }}>
                  <input
                    placeholder='Mail Id'
                    {...formik.getFieldProps('qrMail')}
                    type='text'
                    // defaultValue={("https://yourstorywall.com/content/FRM_" + formik.values.projectNo + "_" + removeSpaces(formik.values.parent[0].label) + "_" + formik.values.startDate.toISOString().slice(0, -14)).toLocaleLowerCase()}
                    name='qrMail'
                    className={clsx(
                      'form-control form-control-solid mb-3 mb-lg-0',
                      { 'is-invalid': formik.touched.qrMail && formik.errors.qrMail },
                      { 'is-valid': formik.touched.qrMail && !formik.errors.qrMail }
                    )}
                    autoComplete='off'
                    disabled={formik.isSubmitting || isEventLoading}
                  />
                  <button
                    className='btn btn-primary'
                    type='button'
                    onClick={() => {
                      copyToClipboard(formik.values.qrMail);
                      // Optionally, provide feedback to the user that the text has been copied.
                      // Example: alert('Copied to clipboard!');
                    }}
                    disabled={formik.isSubmitting || isEventLoading}
                  >
                    Copy
                  </button>
                </div>
                {/* end::Input */}

                {formik.touched.qrMail && formik.errors.qrMail && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.qrMail}</span>
                    </div>
                  </div>
                )}
              </div>
            )
          }

          <div className='mb-7'>
            <label className='required fw-bold fs-6 mb-5'>Info</label>
            <div className='d-flex fv-row'>
              <RadioInput
                formik={formik}
                name='isIntro'
                label='Yes'
                value={true}
                id='kt_modal_update_role_option_0'
                isTemplateLoading={isEventLoading}
              />
            </div>
            <div className='separator separator-dashed my-5'></div>
            <div className='d-flex fv-row'>
              <RadioInput
                formik={formik}
                name='isIntro'
                label='No'
                value={false}
                id='kt_modal_update_role_option_1'
                isTemplateLoading={isEventLoading}
              />
            </div>
            <div className='separator separator-dashed my-5'></div>
          </div>

          {
            formik.values.isIntro && (
              <div className='fv-row mb-7'>
                {/* begin::Label */}
                <label className='required fw-bold fs-6 mb-2'>Info</label>
                {/* end::Label */}

                {/* begin::Input */}
                <div className='input-group' style={{ zIndex: 0 }}>
                  <input
                    placeholder='https://yourstorywall.com/content/FRM'
                    {...formik.getFieldProps('intro')}
                    type='text'
                    // defaultValue={("https://yourstorywall.com/content/FRM_" + formik.values.projectNo + "_" + removeSpaces(formik.values.parent[0].label) + "_" + formik.values.startDate.toISOString().slice(0, -14)).toLocaleLowerCase()}
                    name='intro'
                    className={clsx(
                      'form-control form-control-solid mb-3 mb-lg-0',
                      { 'is-invalid': formik.touched.intro && formik.errors.intro },
                      { 'is-valid': formik.touched.intro && !formik.errors.intro }
                    )}
                    autoComplete='off'
                    disabled={formik.isSubmitting || isEventLoading}
                  />
                  <button
                    className='btn btn-primary'
                    type='button'
                    onClick={() => {
                      copyToClipboard(formik.values.intro);
                      // Optionally, provide feedback to the user that the text has been copied.
                      // Example: alert('Copied to clipboard!');
                    }}
                    disabled={formik.isSubmitting || isEventLoading}
                  >
                    Copy
                  </button>
                </div>
                {/* end::Input */}

                {formik.touched.intro && formik.errors.intro && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.intro}</span>
                    </div>
                  </div>
                )}
              </div>
            )
          }
          <div className='mb-7'>
            <label className='required fw-bold fs-6 mb-5'>Mail</label>
            <div className='d-flex fv-row'>
              <RadioInput
                formik={formik}
                name='isMail'
                label='Yes'
                value={true}
                id='kt_modal_update_role_option_0'
                isTemplateLoading={isEventLoading}
              />
            </div>
            <div className='separator separator-dashed my-5'></div>
            <div className='d-flex fv-row'>
              <RadioInput
                formik={formik}
                name='isMail'
                label='No'
                value={false}
                id='kt_modal_update_role_option_1'
                isTemplateLoading={isEventLoading}
              />
            </div>
            <div className='separator separator-dashed my-5'></div>
          </div>

          {formik.values.isMail && (
            <>
              <div className='mb-7'>
                <label className='required fw-bold fs-6 mb-5'>Mail Type</label>
                <div className='d-flex fv-row'>
                  <RadioInput
                    formik={formik}
                    name='mailType'
                    label='Sendgrid'
                    value='sendgrid'
                    id='kt_modal_update_role_option_2'
                    isTemplateLoading={isEventLoading}
                  />
                </div>
                <div className='separator separator-dashed my-5'></div>
                <div className='d-flex fv-row'>
                  <RadioInput
                    formik={formik}
                    name='mailType'
                    label='Wix Mail'
                    value='wix'
                    id='kt_modal_update_role_option_3'
                    isTemplateLoading={isEventLoading}
                  />
                </div>
                <div className='separator separator-dashed my-5'></div>
              </div>

              {formik.values.mailType === 'sendgrid' && (
                <>
                  <div className='fv-row mb-7'>
                    <label className='required fw-bold fs-6 mb-2'>Mail ID</label>
                    <div className='input-group' style={{ zIndex: 0 }}>
                      <input
                        placeholder='https://yourstorywall.com/content/FRM'
                        {...formik.getFieldProps('sendgrid')}
                        type='text'
                        name='sendgrid'
                        className={clsx(
                          'form-control form-control-solid mb-3 mb-lg-0',
                          { 'is-invalid': formik.touched.sendgrid && formik.errors.sendgrid },
                          { 'is-valid': formik.touched.sendgrid && !formik.errors.sendgrid }
                        )}
                        autoComplete='off'
                        disabled={formik.isSubmitting || isEventLoading}
                      />
                      <button
                        className='btn btn-primary'
                        type='button'
                        onClick={() => {
                          copyToClipboard(formik.values.sendgrid);
                        }}
                        disabled={formik.isSubmitting || isEventLoading}
                      >
                        Copy
                      </button>
                    </div>
                    {formik.touched.sendgrid && formik.errors.sendgrid && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span role='alert'>{formik.errors.sendgrid}</span>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className='fv-row mb-7'>
                    <label className='fw-bold fs-6 mb-2'>Body Copy Mail</label>
                    <textarea
                      className='form-control form-control-solid'
                      rows={3}
                      placeholder='tagline/passage/paragraph for sending in mails'
                      {...formik.getFieldProps('mailParagraph')}
                      name='mailParagraph'
                      autoComplete='off'
                      disabled={formik.isSubmitting || isEventLoading}
                    />
                  </div>
                </>
              )}

              {formik.values.mailType === 'wix' && (
                <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>Wix Mail ID</label>
                  <div className='input-group' style={{ zIndex: 0 }}>
                    <input
                      placeholder='ID'
                      {...formik.getFieldProps('wixMail')}
                      type='text'
                      name='wixMail'
                      className={clsx(
                        'form-control form-control-solid mb-3 mb-lg-0',
                        { 'is-invalid': formik.touched.wixMail && formik.errors.wixMail },
                        { 'is-valid': formik.touched.wixMail && !formik.errors.wixMail }
                      )}
                      autoComplete='off'
                      disabled={formik.isSubmitting || isEventLoading}
                    />
                    <button
                      className='btn btn-primary'
                      type='button'
                      onClick={() => {
                        copyToClipboard(formik.values.wixMail);
                      }}
                      disabled={formik.isSubmitting || isEventLoading}
                    >
                      Copy
                    </button>
                  </div>
                  {formik.touched.wixMail && formik.errors.wixMail && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.wixMail}</span>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </>
          )}
          <div className='mb-7'>
            <label className='required fw-bold fs-6 mb-5'>Storywall Default</label>
            <div className='d-flex fv-row'>
              <RadioInput
                formik={formik}
                name='isMicrositeDefault'
                label='Yes'
                value={true}
                id='kt_modal_update_role_option_0'
                isTemplateLoading={isEventLoading}
              />
            </div>
            <div className='separator separator-dashed my-5'></div>
            <div className='d-flex fv-row'>
              <RadioInput
                formik={formik}
                name='isMicrositeDefault'
                label='No'
                value={false}
                id='kt_modal_update_role_option_1'
                isTemplateLoading={isEventLoading}
              />
            </div>
            <div className='separator separator-dashed my-5'></div>
          </div>

          {
            !formik.values.isMicrositeDefault &&

            <div className='mb-7'>
              <label className='required fw-bold fs-6 mb-5'>Storywall</label>
              <div className='d-flex fv-row'>
                <RadioInput
                  formik={formik}
                  name='isMicrosite'
                  label='Yes'
                  value={true}
                  id='kt_modal_update_role_option_0'
                  isTemplateLoading={isEventLoading}
                />
              </div>
              <div className='separator separator-dashed my-5'></div>
              <div className='d-flex fv-row'>
                <RadioInput
                  formik={formik}
                  name='isMicrosite'
                  label='No'
                  value={false}
                  id='kt_modal_update_role_option_1'
                  isTemplateLoading={isEventLoading}
                />
              </div>
              <div className='separator separator-dashed my-5'></div>
            </div>
          }

          {
            formik.values.isMicrosite && !formik.values.isMicrositeDefault &&

            <>

              {/* begin::Input group */}
              <div className='fv-row mb-7'>
                {/* begin::Label */}
                <label className='required fw-bold fs-6 mb-2'>Name on Storywall</label>
                {/* end::Label */}

                {/* begin::Input */}
                <input
                  placeholder='Activation Title'
                  {...formik.getFieldProps('micrositeName')}
                  value={formik.values.micrositeName}
                  type='text'
                  name='micrositeName'
                  className={clsx(
                    'form-control form-control-solid mb-3 mb-lg-0',
                    { 'is-invalid': formik.touched.micrositeName && formik.errors.micrositeName },
                    {
                      'is-valid': formik.touched.micrositeName && !formik.errors.micrositeName,
                    }
                  )}
                  autoComplete='off'
                  disabled={formik.isSubmitting || isEventLoading}
                />
                {formik.touched.micrositeName && formik.errors.micrositeName && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.micrositeName}</span>
                    </div>
                  </div>
                )}
                {/* end::Input */}
              </div>
              {/* end::Input group */}

              {/* begin::Input group */}
              <div className='fv-row mb-7'>
                <label className='required fw-bold fs-6 mb-2'>Date on Storywall</label>
                <DatePicker showPopperArrow={false}
                  className={clsx(
                    'form-control form-control-solid mb-3 mb-lg-0',
                    { 'is-invalid': formik.touched.micrositeDate && formik.errors.micrositeDate },
                    {
                      'is-valid': formik.touched.micrositeDate && !formik.errors.micrositeDate,
                    }
                  )}
                  selected={formik.values.micrositeDate ? formik.values.micrositeDate : formik.values.startDate}
                  onChange={(micrositeDate) => {
                    formik.setFieldValue('micrositeDate', micrositeDate, false)
                  }}
                  showTimeSelect={false}
                  // timeFormat="HH:mm"
                  dateFormat="dd/MM/yyyy"
                />
              </div>
              {/* end::Input group */}

              <div className='fv-row mb-7'>
                <label className='required fw-bold fs-6 mb-2'>Development Url</label>
                <div className='input-group ' style={{ zIndex: 0 }}>
                  <input
                    placeholder='https://yourstorywall.com/content/dev'
                    {...formik.getFieldProps('micrositeBeta')}
                    type='text'
                    name='micrositeBeta'
                    className={clsx(
                      'form-control form-control-solid mb-3 mb-lg-0',
                      { 'is-invalid': formik.touched.micrositeBeta && formik.errors.micrositeBeta },
                      { 'is-valid': formik.touched.micrositeBeta && !formik.errors.micrositeBeta }
                    )}
                    autoComplete='off'
                    disabled={formik.isSubmitting || isEventLoading}
                  />
                  <button
                    className='btn btn-primary'
                    type='button'
                    onClick={() => {
                      copyToClipboard(formik.values.micrositeBeta);
                      // Optionally, provide feedback to the user that the text has been copied.
                      // Example: alert('Copied to clipboard!');
                    }}
                    disabled={formik.isSubmitting || isEventLoading}
                  >
                    Copy
                  </button>
                </div>
                {formik.touched.micrositeBeta && formik.errors.micrositeBeta && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.micrositeBeta}</span>
                    </div>
                  </div>
                )}
              </div>

              <div className='fv-row mb-7'>
                {/* begin::Label */}
                <label className='required fw-bold fs-6 mb-2'>Production Url (fka Router)</label>
                {/* end::Label */}

                {/* begin::Input */}
                <div className='input-group' style={{ zIndex: 0 }}>
                  <input
                    placeholder='March 23 knvb'
                    {...formik.getFieldProps('microsite')}
                    type='text'
                    name='microsite'
                    className={clsx(
                      'form-control form-control-solid mb-3 mb-lg-0',
                      { 'is-invalid': formik.touched.microsite && formik.errors.microsite },
                      { 'is-valid': formik.touched.microsite && !formik.errors.microsite }
                    )}
                    autoComplete='off'
                    disabled={formik.isSubmitting || isEventLoading}
                  />
                  <button
                    className='btn btn-primary'
                    type='button'
                    onClick={() => {
                      copyToClipboard(formik.values.microsite);
                      // Optionally, provide feedback to the user that the text has been copied.
                      // Example: alert('Copied to clipboard!');
                    }}
                    disabled={formik.isSubmitting || isEventLoading}
                  >
                    Copy
                  </button>
                </div>
                {/* end::Input */}

                {formik.touched.microsite && formik.errors.microsite && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.microsite}</span>
                    </div>
                  </div>
                )}
              </div>

              {


                <div className='mb-7'>
                  <label className='required fw-bold fs-6 mb-5'>Custom Router</label>
                  <div className='d-flex fv-row'>
                    <RadioInput
                      formik={formik}
                      name='isRouter'
                      label='Yes'
                      value={true}
                      id='kt_modal_update_role_option_0'
                      isTemplateLoading={isEventLoading}
                    />
                  </div>
                  <div className='separator separator-dashed my-5'></div>
                  <div className='d-flex fv-row'>
                    <RadioInput
                      formik={formik}
                      name='isRouter'
                      label='No'
                      value={false}
                      id='kt_modal_update_role_option_1'
                      isTemplateLoading={isEventLoading}
                    />
                  </div>
                  <div className='separator separator-dashed my-5'></div>
                </div>
              }

              {
                formik.values.isRouter &&
                <>
                  <div className='fv-row mb-7'>
                    {/* begin::Label */}
                    <label className='required fw-bold fs-6 mb-2'>Router</label>
                    {/* end::Label */}

                    {/* begin::Input */}
                    <div className='input-group' style={{ zIndex: 0 }}>
                      <input
                        placeholder='Default'
                        {...formik.getFieldProps('router')}
                        type='text'
                        name='router'
                        className={clsx(
                          'form-control form-control-solid mb-3 mb-lg-0',
                          { 'is-invalid': formik.touched.router && formik.errors.router },
                          { 'is-valid': formik.touched.router && !formik.errors.router }
                        )}
                        autoComplete='off'
                        disabled={formik.isSubmitting || isEventLoading}
                      />
                      <button
                        className='btn btn-primary'
                        type='button'
                        onClick={() => {
                          copyToClipboard(formik.values.router);
                          // Optionally, provide feedback to the user that the text has been copied.
                          // Example: alert('Copied to clipboard!');
                        }}
                        disabled={formik.isSubmitting || isEventLoading}
                      >
                        Copy
                      </button>
                    </div>
                    {/* end::Input */}

                    {formik.touched.router && formik.errors.router && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span role='alert'>{formik.errors.router}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </>
              }
              {/* end::Input group */}
            </>
          }

          <div className='mb-7'>
            <label className='required fw-bold fs-6 mb-5'>Faceswap API</label>
            <div className='d-flex fv-row'>
              <RadioInput
                formik={formik}
                name='apiType'
                label='Magic'
                value={"magic"}
                id='kt_modal_update_role_option_0'
                isTemplateLoading={isEventLoading}
              />
            </div>
            <div className='separator separator-dashed my-5'></div>
            <div className='d-flex fv-row'>
              <RadioInput
                formik={formik}
                name='apiType'
                label='Morfran'
                value={"morfran"}
                id='kt_modal_update_role_option_1'
                isTemplateLoading={isEventLoading}
              />
            </div>
            <div className='separator separator-dashed my-5'></div>
          </div>

          {
            formik.values.apiType === 'magic' &&

            <div className='mb-7'>
              <label className='required fw-bold fs-6 mb-5'>Magic API Version</label>
              <div className='d-flex fv-row'>
                <RadioInput
                  formik={formik}
                  name='apiVersion'
                  label='v3'
                  value={'v3'}
                  id='kt_modal_update_role_option_1'
                  isTemplateLoading={isEventLoading}
                />
              </div>
              <div className='separator separator-dashed my-5'></div>

              <div className='d-flex fv-row'>
                <RadioInput
                  formik={formik}
                  name='apiVersion'
                  label='v2'
                  value={'v2'}
                  id='kt_modal_update_role_option_0'
                  isTemplateLoading={isEventLoading}
                />
              </div>
              <div className='separator separator-dashed my-5'></div>
              <div className='d-flex fv-row'>
                <RadioInput
                  formik={formik}
                  name='apiVersion'
                  label='v1'
                  value={'v1'}
                  id='kt_modal_update_role_option_1'
                  isTemplateLoading={isEventLoading}
                />
              </div>
              <div className='separator separator-dashed my-5'></div>
            </div>
          }

          {
            formik.values.apiType === 'magic' &&

            <div className='mb-7'>
              <label className='required fw-bold fs-6 mb-5'>Enhance Photos</label>
              <div className='d-flex fv-row'>
                <RadioInput
                  formik={formik}
                  name='apiEnhance'
                  label='Yes'
                  value={true}
                  id='kt_modal_update_role_option_0'
                  isTemplateLoading={isEventLoading}
                />
              </div>
              <div className='separator separator-dashed my-5'></div>
              <div className='d-flex fv-row'>
                <RadioInput
                  formik={formik}
                  name='apiEnhance'
                  label='No'
                  value={false}
                  id='kt_modal_update_role_option_1'
                  isTemplateLoading={isEventLoading}
                />
              </div>
              <div className='separator separator-dashed my-5'></div>
            </div>
          }

          <div className='mb-7'>
            <label className='required fw-bold fs-6 mb-5'>Testing Mode</label>
            <div className='d-flex fv-row'>
              <RadioInput
                formik={formik}
                name='testingMode'
                label='Yes'
                value={true}
                id='kt_modal_update_role_option_0'
                isTemplateLoading={isEventLoading}
              />
            </div>
            <div className='separator separator-dashed my-5'></div>
            <div className='d-flex fv-row'>
              <RadioInput
                formik={formik}
                name='testingMode'
                label='No'
                value={false}
                id='kt_modal_update_role_option_1'
                isTemplateLoading={isEventLoading}
              />
            </div>
            <div className='separator separator-dashed my-5'></div>
          </div>

          <div className='mb-7'>
            <label className='required fw-bold fs-6 mb-5'>Auto Print / Direct Print</label>
            <div className='d-flex fv-row'>
              <RadioInput
                formik={formik}
                name='autoPrint'
                label='Yes'
                value={true}
                id='kt_modal_update_activation_auto_print_yes'
                isTemplateLoading={isEventLoading}
              />
            </div>
            <div className='separator separator-dashed my-5'></div>
            <div className='d-flex fv-row'>
              <RadioInput
                formik={formik}
                name='autoPrint'
                label='No'
                value={false}
                id='kt_modal_update_activation_auto_print_no'
                isTemplateLoading={isEventLoading}
              />
            </div>
            <div className='separator separator-dashed my-5'></div>
          </div>

          <div className='mb-7'>
            <label className='required fw-bold fs-6 mb-5'>Printing</label>
            <div className='d-flex fv-row'>
              <RadioInput
                formik={formik}
                name='isPrintDefault'
                label='Normal'
                value={true}
                id='kt_modal_update_role_option_0'
                isTemplateLoading={isEventLoading}
              />
            </div>
            <div className='separator separator-dashed my-5'></div>
            <div className='d-flex fv-row'>
              <RadioInput
                formik={formik}
                name='isPrintDefault'
                label='Extended'
                value={false}
                id='kt_modal_update_role_option_1'
                isTemplateLoading={isEventLoading}
              />
            </div>
            <div className='separator separator-dashed my-5'></div>
          </div>

          <div className='fv-row mb-7'>
            <div className='d-flex justify-content-between align-items-center px-2 mb-2'>
              <label className='required fw-bold fs-6 mb-0'>Printable Template</label>
              <div className='d-flex'>
                <button
                  className='btn btn-primary me-2'
                  type='button'
                  onClick={() => {
                    copyToClipboard(formik.values.printableTemplateId);
                  }}
                  disabled={formik.isSubmitting || isEventLoading || !formik.values.printableTemplateId}
                >
                  Copy
                </button>
                <a
                  className='btn btn-light-primary'
                  href={printableTemplateUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {printableTemplateId ? 'Open Editor' : 'Create Template'}
                </a>
              </div>
            </div>
            <div
              className='px-2'
              onClick={(clickEvent) => {
                clickEvent.stopPropagation();
              }}
            >
              <ReactSelect
                key={printableTemplateSelectKey}
                value={selectedPrintingTemplate}
                placeholder='Tap or Search'
                hideSelectedOptions={false}
                onChange={(newValue) => {
                  formik.setFieldValue('printableTemplateId', newValue?.value || '', false)
                }}
                filterOption={(option, rawInput) => {
                  const normalizedInput = rawInput.toLowerCase().trim()
                  if (!normalizedInput) {
                    return true
                  }

                  const searchArray = [
                    ...(option.data.tags || []),
                    option.label,
                    option.value,
                  ]
                    .filter((value) => typeof value === 'string')
                    .map((value: string) => value.toLowerCase())

                  return searchArray.some((value: string) => value.includes(normalizedInput))
                }}
                backspaceRemovesValue={false}
                blurInputOnSelect={false}
                className='fs-6'
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 0,
                  colors: {
                    ...theme.colors,
                  },
                })}
                styles={{
                  control: (base) => ({
                    ...base,
                    padding: "5px",
                    border: "none",
                    borderRadius: 10,
                    boxShadow: '#3d88a614 0px 0px 20px 0px',
                  }),
                  menu: (base) => ({
                    ...base,
                    backgroundColor: "white",
                    padding: "10px",
                    border: "none",
                    borderRadius: 10,
                    boxShadow: '#3d88a614 0px 0px 20px 0px',
                  }),
                  singleValue: (base) => ({ ...base, color: "#000", borderRadius: 10 }),
                }}
                formatOptionLabel={(option) => (
                  <div className='d-flex align-items-center'>
                    <div className='symbol symbol-50px overflow-hidden me-3'>
                      {option.avatar ? (
                        <div
                          className='symbol-label'
                          onMouseEnter={(mouseEvent) => showPrintableTemplatePreview(mouseEvent, option)}
                          onMouseLeave={schedulePrintableTemplatePreviewHide}
                          style={{ cursor: 'zoom-in' }}
                        >
                          <img src={option.avatar} alt={option.label} className='w-100' />
                        </div>
                      ) : (
                        <div className='symbol-label fs-3 bg-light-primary text-primary'>
                          {option.label?.[0]}
                        </div>
                      )}
                    </div>
                    <div className='d-flex flex-column'>
                      <span className='text-gray-800 text-hover-primary mb-1'>{option.label}</span>
                      <span style={{ color: 'black' }}>{option.value}</span>
                    </div>
                  </div>
                )}
                isDisabled={formik.isSubmitting || isEventLoading}
                isLoading={isPrintingTemplatesLoading}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                name='printableTemplateId'
                options={printingTemplates}
                noOptionsMessage={() => {
                  if (isPrintingTemplatesLoading) {
                    return 'Loading printable templates...'
                  }
                  if (printingTemplatesError) {
                    return 'Failed to load printable templates'
                  }
                  return 'No printable templates found'
                }}
              />
            </div>
            <div className='form-text px-2 mt-2'>
              {printableTemplateId
                ? 'The editor will load the selected printable template.'
                : 'No template selected yet. This opens a blank editor to start a new one.'}
            </div>
            {printingTemplatesError && (
              <div className='fv-plugins-message-container px-2 mt-2'>
                <div className='fv-help-block'>
                  <span role='alert'>Printable templates error: {printingTemplatesError}</span>
                </div>
              </div>
            )}
            {formik.touched.printableTemplateId && formik.errors.printableTemplateId && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.printableTemplateId}</span>
                </div>
              </div>
            )}
          </div>

          <div className='mb-7'>
            <label className='required fw-bold fs-6 mb-5'>DOOH</label>
            <div className='d-flex fv-row'>
              <RadioInput
                formik={formik}
                name='isDooh'
                label='Yes'
                value={true}
                id='kt_modal_update_role_option_0'
                isTemplateLoading={isEventLoading}
              />
            </div>
            <div className='separator separator-dashed my-5'></div>
            <div className='d-flex fv-row'>
              <RadioInput
                formik={formik}
                name='isDooh'
                label='No'
                value={false}
                id='kt_modal_update_role_option_1'
                isTemplateLoading={isEventLoading}
              />
            </div>
            <div className='separator separator-dashed my-5'></div>
          </div>




          {
            formik.values.isDooh &&

            <>
              {/* end::Input group */}

              {/* begin::Input group */}
              <div className='fv-row mb-7'>
                <label className='required fw-bold fs-6 mb-2'>DOOH Link</label>
                <div className='input-group' style={{ zIndex: 0 }}>
                  <input
                    placeholder='https://yourstorywall.com/content/'
                    {...formik.getFieldProps('dooh')}
                    type='text'
                    name='dooh'
                    className={clsx(
                      'form-control form-control-solid mb-3 mb-lg-0',
                      { 'is-invalid': formik.touched.dooh && formik.errors.dooh },
                      { 'is-valid': formik.touched.dooh && !formik.errors.dooh }
                    )}
                    autoComplete='off'
                    disabled={formik.isSubmitting || isEventLoading}
                  />
                  <button
                    className='btn btn-primary'
                    type='button'
                    onClick={() => {
                      copyToClipboard(formik.values.dooh);
                      // Optionally, provide feedback to the user that the text has been copied.
                      // Example: alert('Copied to clipboard!');
                    }}
                    disabled={formik.isSubmitting || isEventLoading}
                  >
                    Copy
                  </button>
                </div>
                {formik.touched.dooh && formik.errors.dooh && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.dooh}</span>
                    </div>
                  </div>
                )}
              </div>
              {/* end::Input group */}

              {/* begin::Input group */}
              <div className='fv-row mb-7'>
                {/* begin::Label */}
                <label className='required fw-bold fs-6 mb-2'>Quit Claim</label>
                {/* end::Label */}

                {/* begin::Input */}
                <div className='input-group' style={{ zIndex: 0 }}>
                  <input
                    placeholder='https://yourstorywall.com/content/'
                    {...formik.getFieldProps('quitclaim')}
                    type='text'
                    name='quitclaim'
                    className={clsx(
                      'form-control form-control-solid mb-3 mb-lg-0',
                      { 'is-invalid': formik.touched.quitclaim && formik.errors.quitclaim },
                      { 'is-valid': formik.touched.quitclaim && !formik.errors.quitclaim },
                    )}
                    autoComplete='off'
                    disabled={formik.isSubmitting || isEventLoading}
                  />
                  <button
                    className='btn btn-primary'
                    type='button'
                    onClick={() => {
                      copyToClipboard(formik.values.quitclaim);
                      // Optionally, provide feedback to the user that the text has been copied.
                      // Example: alert('Copied to clipboard!');
                    }}
                    disabled={formik.isSubmitting || isEventLoading || !formik.values.quitclaim}
                  >
                    Copy
                  </button>
                </div>
                {/* end::Input */}

                {formik.touched.quitclaim && formik.errors.quitclaim && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.quitclaim}</span>
                    </div>
                  </div>
                )}
              </div>
              {/* end::Input group */}

              <div className='fv-row mb-7'>
                {/* begin::Label */}
                <label className='required fw-bold fs-6 mb-2'>Mail ID</label>
                {/* end::Label */}

                {/* begin::Input */}
                <div className='input-group' style={{ zIndex: 0 }}>
                  <input
                    placeholder='https://yourstorywall.com/content/FRM'
                    {...formik.getFieldProps('sendgridDooh')}
                    type='text'
                    name='sendgridDooh'
                    className={clsx(
                      'form-control form-control-solid mb-3 mb-lg-0',
                      { 'is-invalid': formik.touched.sendgridDooh && formik.errors.sendgridDooh },
                      { 'is-valid': formik.touched.sendgridDooh && !formik.errors.sendgridDooh }
                    )}
                    autoComplete='off'
                    disabled={formik.isSubmitting || isEventLoading}
                  />
                  <button
                    className='btn btn-primary'
                    type='button'
                    onClick={() => {
                      copyToClipboard(formik.values.sendgridDooh);
                      // Optionally, provide feedback to the user that the text has been copied.
                      // Example: alert('Copied to clipboard!');
                    }}
                    disabled={formik.isSubmitting || isEventLoading}
                  >
                    Copy
                  </button>
                </div>
                {/* end::Input */}

                {formik.touched.sendgridDooh && formik.errors.sendgridDooh && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.sendgridDooh}</span>
                    </div>
                  </div>
                )}
              </div>

              <div className='fv-row mb-7'>
                {/* begin::Label */}
                <label className=' fw-bold fs-6 mb-2'>Body Copy Mail</label>
                {/* end::Label */}
                {/* begin::Input */}
                <textarea
                  className='form-control form-control-solid '
                  rows={3}
                  placeholder='tagline/passage/paragraph for sending in mails'
                  {...formik.getFieldProps('mailParagraphDooh')}
                  name='mailParagraphDooh'
                  autoComplete='off'
                  disabled={formik.isSubmitting || isEventLoading}
                ></textarea>
                {/* end::Input */}
              </div>

            </>
          }



          <div className='mb-7'>
            <label className='required fw-bold fs-6 mb-5'>Analytics</label>
            <div className='d-flex fv-row'>
              <RadioInput
                formik={formik}
                name='isAnalytics'
                label='Yes'
                value={true}
                id='kt_modal_update_role_option_0'
                isTemplateLoading={isEventLoading}
              />
            </div>
            <div className='separator separator-dashed my-5'></div>
            <div className='d-flex fv-row'>
              <RadioInput
                formik={formik}
                name='isAnalytics'
                label='No'
                value={false}
                id='kt_modal_update_role_option_1'
                isTemplateLoading={isEventLoading}
              />
            </div>
            <div className='separator separator-dashed my-5'></div>
          </div>

          {
            formik.values.isAnalytics &&

            <div className='fv-row mb-7'>
              {/* begin::Label */}
              <label className=' fw-bold fs-6 mb-2'>Embed Code (Looker Studio Report)</label>
              {/* end::Label */}
              {/* begin::Input */}
              <textarea
                className='form-control form-control-solid mb-8'
                rows={1}
                placeholder='tagline/passage/paragraph for sending in mails'
                {...formik.getFieldProps('embedCode')}
                name='embedCode'
                autoComplete='off'
                disabled={formik.isSubmitting || isEventLoading}
              ></textarea>
              {/* end::Input */}
            </div>
          }



        </div>
        {/* end::Scroll */}

        {/* begin::Actions */}
        <div className='text-center pt-15'>
          <button
            type='reset'
            onClick={() => cancel()}
            className='btn btn-light me-3'
            data-kt-events-modal-action='cancel'
            disabled={formik.isSubmitting || isEventLoading}
          >
            Discard
          </button>

          <button
            type='submit'
            className='btn btn-primary'
            data-kt-events-modal-action='submit'
            disabled={isEventLoading || formik.isSubmitting || !formik.isValid || !formik.touched}
          >
            <span className='indicator-label'>Submit</span>
            {(formik.isSubmitting || isEventLoading) && (
              <span className='indicator-progress'>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
        {/* end::Actions */}
      </form >
      {printableTemplatePreview && (
        <div
          className='printable-template-preview-overlay'
          onMouseEnter={clearPrintableTemplatePreviewTimers}
          onMouseLeave={schedulePrintableTemplatePreviewHide}
          style={{
            position: 'fixed',
            top: `${printableTemplatePreview.top}px`,
            left: `${printableTemplatePreview.left}px`,
            transform: 'translate(-50%, -50%)',
            width: '300px',
            maxWidth: '80vw',
            maxHeight: '85vh',
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 18px 40px rgba(0,0,0,0.25), 0 0 0 1px rgba(0,0,0,0.08)',
            zIndex: 1800,
            background: 'rgba(255,255,255,0.96)',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            animation: 'printableTemplatePreviewPopIn 0.22s cubic-bezier(0.2, 0.8, 0.2, 1) forwards',
            pointerEvents: 'auto',
          }}
        >
          <img
            src={printableTemplatePreview.avatar}
            alt={printableTemplatePreview.label}
            style={{
              width: '100%',
              maxHeight: 'calc(85vh - 56px)',
              objectFit: 'contain',
              display: 'block',
              background: '#f5f8fa',
            }}
          />
          <div
            style={{
              padding: '10px 12px',
              borderTop: '1px solid rgba(0,0,0,0.08)',
              color: '#181c32',
              background: 'rgba(255,255,255,0.93)',
              textAlign: 'center',
              fontWeight: 500,
              fontSize: '13px',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }}
            title={`${printableTemplatePreview.label} (${printableTemplatePreview.value})`}
          >
            {printableTemplatePreview.label}
          </div>
        </div>
      )}
      <style>
        {`
          @keyframes printableTemplatePreviewPopIn {
            0% {
              opacity: 0;
              transform: translate(-50%, -50%) scale(0.92);
              filter: blur(2px);
            }
            100% {
              opacity: 1;
              transform: translate(-50%, -50%) scale(1);
              filter: blur(0);
            }
          }
        `}
      </style>
      {(formik.isSubmitting || isEventLoading) && <EventsListLoading />
      }
    </>
  )
}

export { EventEditModalForm }
